import React, { Component } from 'react';
import './ExtensionInfo.css';

const CHROME_TITLE = 'Chrome';
const CHROME_TEXT_TOP = 'Access your bitmoji on any website by';
const CHROME_TEXT_BOT = 'clicking the Bitmoji icon beside the address bar.';
class CongratsInfoExtension extends Component {
    render() {

        return (
            <div className="extension-info" >
                <div className="chrome-header-icon">
                    <span className="chrome-title">
                        <p>{CHROME_TITLE}</p>
                    </span>
                </div>
                <div className="chrome-images-wrapper">
                    <div className="extension-text" >
                        <p>{CHROME_TEXT_TOP}</p>
                        <p>{CHROME_TEXT_BOT}</p>
                    </div>
                    <div className="extension-browser-bar" />
                </div>
            </div>
        );
    }
}

export default CongratsInfoExtension;



// WEBPACK FOOTER //
// ./src/components/congrats_view/ExtensionInfo.js